import { Temporal } from "@js-temporal/polyfill";
export const commonZones = [
  ["Asia/Beirut", "Beirut, Lebanon"],
  ["Europe/Paris", "Paris, France"],
  ["Europe/London", "London, United Kingdom"],
  ["Asia/Dubai", "Dubai, United Arab Emirates"],
  ["Asia/Riyadh", "Riyadh, Saudi Arabia"],
  ["Europe/Berlin", "Berlin, Germany"],
  ["America/New_York", "New York, United States"],
  ["America/Chicago", "Chicago, United States"],
  ["America/Los_Angeles", "Los Angeles, United States"],
  ["America/Toronto", "Toronto, Canada"],
  ["Asia/Kolkata", "Kolkata, India"],
  ["Asia/Singapore", "Singapore"],
  ["Asia/Tokyo", "Tokyo, Japan"],
  ["Australia/Sydney", "Sydney, Australia"],
  ["UTC", "Coordinated Universal Time"],
] as const;
export function validTimezone(timezone: string) {
  try {
    Temporal.Now.zonedDateTimeISO(timezone);
    return true;
  } catch {
    return false;
  }
}
export function detectTimezone(
  resolve = () => Intl.DateTimeFormat().resolvedOptions().timeZone,
) {
  try {
    const zone = resolve();
    return validTimezone(zone) ? zone : "Asia/Beirut";
  } catch {
    return "Asia/Beirut";
  }
}
export function timezoneLocation(zone: string) {
  return (
    commonZones.find(([id]) => id === zone)?.[1] ||
    zone.split("/").reverse().join(", ").replaceAll("_", " ")
  );
}
export function timezoneOffset(zone: string, now = Date.now()) {
  const offset =
    Temporal.Instant.fromEpochMilliseconds(now).toZonedDateTimeISO(zone).offset;
  return offset === "+00:00" ? "UTC" : `UTC${offset.replace("-", "−")}`;
}
export function timezoneLabel(zone: string, now = Date.now()) {
  return `${timezoneLocation(zone)} · ${timezoneOffset(zone, now)}`;
}
export function availableTimezones(current: string) {
  return [
    ...new Set([
      ...commonZones.map(([id]) => id),
      ...Intl.supportedValuesOf("timeZone"),
      current,
    ]),
  ].filter(validTimezone);
}
